import { ApiResult, HttpClient } from "../http.js";
import { CustomSkillDto } from "../types/custom-skills.js";

export interface CreateCustomSkillPayload {
  name: string;
  trade: string;
}

export interface ListCustomSkillsQuery {
  trade?: string;
}

export class CustomSkillsApi {
  constructor(private readonly http: HttpClient) {}

  list(query: ListCustomSkillsQuery = {}): Promise<ApiResult<CustomSkillDto[]>> {
    return this.http.get<CustomSkillDto[]>("/api/custom-skills", { query: { ...query } });
  }

  create(payload: CreateCustomSkillPayload): Promise<ApiResult<CustomSkillDto>> {
    return this.http.post<CustomSkillDto>("/api/custom-skills", { body: payload });
  }

  remove(id: string): Promise<ApiResult<string>> {
    return this.http.delete<string>(`/api/custom-skills/${encodeURIComponent(id)}`);
  }
}
